import * as tslib_1 from "tslib";
import CreateStaffSelector from "../../../../../form/src/common/components/createStaffSelector.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
let StaffSelectorDesign = class StaffSelectorDesign extends Vue {
    render(h) {
        return h('create-staff-selector', { props: { opts: { disabled: true }
            } });
    }
};
tslib_1.__decorate([
    Prop()
], StaffSelectorDesign.prototype, "control", void 0);
StaffSelectorDesign = tslib_1.__decorate([
    Component({
        name: 'StaffSelectorDesign',
        components: {
            CreateStaffSelector
        }
    })
], StaffSelectorDesign);
export default StaffSelectorDesign;
